<ng-container>
  <mat-accordion class="right-side-bar" >
    <mat-expansion-panel
      [expanded]="isPanelExpanded"
    >
      <mat-expansion-panel-header
        [collapsedHeight]="'42px'"
        [expandedHeight]="'42px'"
        (click)="onExpansionPanelClicked()"
      >
        <itb-icon [className]="iconName"> </itb-icon>
        <itb-text [className]="'text-default'" [text]="text"></itb-text>
      </mat-expansion-panel-header>
      <ng-content></ng-content>
    </mat-expansion-panel>
    <div
      class="rsb-add-btn"
      (click)="onAddButtonClicked()"
      *ngIf="hasAddNewButton && !isDisabled"
    >
      <itb-icon [tooltipText]="buttonTooltipText" [className]="buttonIconName"></itb-icon>
      <span>{{buttonText}}</span>
    </div>
    <div
      class="rsb-add-btn"
      *ngIf="hasAddNewButton && isDisabled"
    >
      <itb-icon [tooltipText]="buttonTooltipText" [className]="buttonIconName"></itb-icon>
      <span>{{buttonText}}</span>
    </div>
  </mat-accordion>
</ng-container>
